"use client";
import Link from "next/link";
import React from "react";
import ButtonDefault from "@/library/components/clickables/ButtonDefault";

export default function StoryBlokLink({ link, buttonText, buttonType, size }) {
  const href =
    link?.linktype === "story" ? `/${link?.cached_url}` : link?.url || "/";

  if (!href || href === "/") {
    return <span className="pointer-events-none opacity-50">{buttonText}</span>;
  }

  return (
    <Link href={href}>
      <ButtonDefault
        buttonText={buttonText}
        buttonType={buttonType}
        size={size}
      />
    </Link>
  );
}
